import { useNavigation } from "@react-navigation/native";
import { DocumentReference } from "@atgof-firebase/firebase";
import { useContext } from "react";
import { useProject } from "../data/useProject";
import { useDocument } from "../data/useDocument";
import {
  isCharacterCategory,
  SheetCategory,
  sheetsCollection,
  SheetSubjectKind,
} from "../common/sheet";
import { SubjectSpec } from "../common/subject";
import { UserContext } from "../data/userContext";
import { generateNextSlateAttrs } from "../data/team";
import { episodeForScene } from "../common/episode";
import { objectCreationAttributes } from "../data/util";
import NewSheetOrApplicandButton from "./NewSheetOrApplicandButton";

export type NewSheetContext = {
  episodeRef?: DocumentReference;
  sceneRef?: DocumentReference;
  subject?: SubjectSpec;
};

export default function NewSheetButton({
  episodeRef,
  sceneRef,
  subject,
  restrictToCategories,
}: NewSheetContext & { restrictToCategories?: SheetCategory[] }) {
  const { navigate } = useNavigation();
  const { user } = useContext(UserContext);
  const project = useDocument(useProject());
  const newSheetAction = (category: SheetCategory) => () => {
    if (!project) return;
    const forCharacter = isCharacterCategory(category);
    const kind: SheetSubjectKind | undefined = forCharacter
      ? "character"
      : category === "arts"
        ? "set"
        : undefined;
    const newDoc = sheetsCollection(project.ref).doc();
    const isPA = category === "pa";
    (isPA
      ? generateNextSlateAttrs(sceneRef, project.get("noSlates") ?? false)
      : Promise.resolve({})
    ).then((extra) =>
      newDoc.set({
        ...(sceneRef
          ? {
              scene: sceneRef,
              ...(episodeRef
                ? { episode: episodeRef }
                : sceneRef
                  ? { episode: episodeForScene(sceneRef) }
                  : {}),
            }
          : {}),
        ...(subject && subject.subjectKind === kind
          ? { [kind]: subject.subjectName }
          : {}),
        category,
        ...objectCreationAttributes(user.ref),
        ...(forCharacter ? { look: "day" } : {}),
        ...(isPA ? { "pa:sound": { key: "sync" } } : {}),
        ...extra,
      }),
    );
    navigate("sheet", { isNew: "true", path: newDoc.path });
  };
  return (
    <NewSheetOrApplicandButton
      kind="sheet"
      actionForCategory={newSheetAction}
      restrictToCategories={restrictToCategories}
    />
  );
}
